import { B000130BumonNm, catchRestError, RestClient } from "clients/rest";
import { UseFormReturn } from "react-hook-form";
import { PageableResponse } from "../PageableResponse";

export type B000140FindRequest = Partial<{
  eigyoCd: string;
  bumonCd: string;
  shainCdFrom: string;
  shainCdTo: string;
  name: string;
  // 削除予定区分チェック除外区分
  deljogaiKbn: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B000140FindResponse = {
  shainCd: string;
  shainNm: string;
  shainKana: string;
  bumonNm: string;
  bumonCd: string;
  eigyoCd: string;
  kengenId: string;
  naisenNo: string;
  keitaiNo: string;
  mailaddress: string;
  seibetsuKbn: string;
  seinenYmd: string;
  nyushaYmd: string;
  taishaYmd: string;
  sakujoyoteiKbn: string;
  version: string;
};

export const B000140Find = (props: B000140FindRequest) => {
  return RestClient.get<PageableResponse<B000140FindResponse>>("b000140/find", {
    params: props,
  });
};

export type B000140GetRequest = {
  shainCd: string;
};

export const B000140Get = (props: B000140GetRequest) => {
  return RestClient.get("b000140/get", {
    params: props,
  });
};

//社員名表示
export const B000140ShainNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shainCd === "") {
    methods.setValue("shainNm", data.shainCd);
    return;
  }
  await B000140Get({ shainCd: data.shainCd })
    .then((response) => {
      methods.setValue("shainNm", response.data.shainNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shainNm", "");
    });
};

//受注入力用(フロント詳細設計処理詳細5に該当する)の担当者名表示処理
export const B000140Shain = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shainCd === "") {
    methods.setValue("shainNm", "");
    methods.setValue("bumonCd", "");
    methods.setValue("bumonNm", "");
    methods.setValue("eigyoCd", "");
    return;
  }
  await B000140Get({ shainCd: data.shainCd })
    .then((response) => {
      methods.setValue("shainNm", response.data.shainNm ?? "");
      methods.setValue("bumonCd", response.data.bumonCd ?? "");
      methods.setValue("eigyoCd", response.data.eigyoCd ?? "");
      // 部門名表示
      B000130BumonNm(methods, navigate, setMsg);
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shainNm", "");
      methods.setValue("bumonCd", "");
      methods.setValue("bumonNm", "");
      methods.setValue("eigyoCd", "");
    });
};

//アシスタント名表示
export const B000140AssistantNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.assistantCd === "") {
    methods.setValue("assistantNm", data.assistantCd);
    return;
  }
  await B000140Get({ shainCd: data.assistantCd })
    .then((response) => {
      methods.setValue("assistantNm", response.data.shainNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("assistantNm", "");
    });
};

//社員名(From)表示
export const B000140ShainNmFrom = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shainCdFrom === "") {
    methods.setValue("shainNmFrom", data.shainCdFrom);
    return;
  }
  await B000140Get({ shainCd: data.shainCdFrom })
    .then((response) => {
      methods.setValue("shainNmFrom", response.data.shainNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shainNmFrom", "");
    });
};

//社員名(To)表示
export const B000140ShainNmTo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shainCdTo === "") {
    methods.setValue("shainNmTo", data.shainCdTo);
    return;
  }
  await B000140Get({ shainCd: data.shainCdTo })
    .then((response) => {
      methods.setValue("shainNmTo", response.data.shainNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shainNmTo", "");
    });
};

//オペレータ名表示
export const B000140OperatorNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.operatorCd === "") {
    methods.setValue("operatorNm", data.operatorCd);
    return;
  }
  await B000140Get({ shainCd: data.operatorCd })
    .then((response) => {
      methods.setValue("operatorNm", response.data.shainNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("operatorNm", "");
    });
};

//倉庫移動入力、ロケーション移動入力担当者表示処理
export const B000140ShainNmBumonCd = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shainCd === "") {
    methods.setValue("shainNm", data.shainCd);
    methods.setValue("bumonCd", data.shainCd);
    return;
  }
  await B000140Get({ shainCd: data.shainCd })
    .then((response) => {
      methods.setValue("shainNm", response.data.shainNm ?? "");
      methods.setValue("bumonCd", response.data.bumonCd ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shainNm", "");
      methods.setValue("bumonCd", "");
    });
};

//在庫調整入力担当者名表示処理
export const B000140ShainBumon = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shainCd === "") {
    methods.setValue("shainNm", data.shainCd);
    methods.setValue("bumonCd", data.shainCd);
    methods.setValue("bumonNm", data.shainCd);
    return;
  }
  await B000140Get({ shainCd: data.shainCd })
    .then((response) => {
      methods.setValue("shainNm", response.data.shainNm ?? "");
      methods.setValue("bumonCd", response.data.bumonCd ?? "");
      methods.setValue("bumonNm", response.data.bumonNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shainNm", "");
      methods.setValue("bumonCd", "");
      methods.setValue("bumonNm", "");
    });
};

//担当者名表示処理
export const B000140TantoushaNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.tantoushaCd === "") {
    methods.setValue("tantoushaNm", data.tantoushaCd);
    return;
  }
  await B000140Get({ shainCd: data.tantoushaCd })
    .then((response) => {
      methods.setValue("tantoushaNm", response.data.shainNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("tantoushaNm", "");
    });
};

//更新者名表示処理
export const B000140UpdshainNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.updshainCd === "") {
    methods.setValue("updshainNm", data.updshainCd);
    return;
  }
  await B000140Get({ shainCd: data.updshainCd })
    .then((response) => {
      methods.setValue("updshainNm", response.data.shainNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("updshainNm", "");
    });
};

// 売掛担当者名表示処理
export const B000140UrikakeshainNmr = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.urikakeshainCd === "") {
    methods.setValue("urikakeshainNmr", data.urikakeshainCd);
    return;
  }
  await B000140Get({ shainCd: data.urikakeshainCd })
    .then((response) => {
      methods.setValue("urikakeshainNmr", response.data.shainNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("urikakeshainNmr", "");
    });
};

//社員名(From)表示(セットするのはshainNmrFrom)
export const B000140ShainNmrFrom = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shainCdFrom === "") {
    methods.setValue("shainNmrFrom", data.shainCdFrom);
    return;
  }
  await B000140Get({ shainCd: data.shainCdFrom })
    .then((response) => {
      methods.setValue("shainNmrFrom", response.data.shainNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shainNmrFrom", "");
    });
};

//社員名(To)表示(セットするのはshainNmrTo)
export const B000140ShainNmrTo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shainCdTo === "") {
    methods.setValue("shainNmrTo", data.shainCdTo);
    return;
  }
  await B000140Get({ shainCd: data.shainCdTo })
    .then((response) => {
      methods.setValue("shainNmrTo", response.data.shainNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shainNmrTo", "");
    });
};

// 売掛担当者名表示処理
export const B000140UrikakeshainNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.urikakeshainCd === "") {
    methods.setValue("urikakeshainNm", data.urikakeshainCd);
    return;
  }
  await B000140Get({ shainCd: data.urikakeshainCd })
    .then((response) => {
      methods.setValue("urikakeshainNm", response.data.shainNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("urikakeshainNm", "");
    });
};

// 売掛担当者名、部門コード取得処理
export const B000140UrikakeshainNmBumonCd = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.urikakeshainCd === "") {
    methods.setValue("urikakeshainNm", data.urikakeshainCd);
    methods.setValue("urikakebumonCd", data.urikakeshianCd);
    return;
  }
  await B000140Get({ shainCd: data.urikakeshainCd })
    .then((response) => {
      methods.setValue("urikakeshainNm", response.data.shainNm ?? "");
      methods.setValue("urikakebumonCd", response.data.bumonCd ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("urikakeshainNm", "");
      methods.setValue("urikakebumonCd", "");
    });
};
